import React from 'react';
import cn from 'classnames';

import Message from './Message';
import styles from './validation-alert.module.scss';

interface IValidationAlertProps {
  children: any;
  position?: 'top' | 'bottom';
  text?: string;
  // true - message overlaps everything below the itself
  // false - message shifts content below the itself
  isFloating?: boolean;
  // true - message haven't have width limitation
  // false - width limited by child` width
  allowOverflow?: boolean;
  isVisible: boolean;
}

export default function ValidationAlert({
  children,
  position = 'bottom',
  isFloating = true,
  text,
  allowOverflow = false,
  isVisible = false,
}: IValidationAlertProps) {
  const validationWrapperClass = cn(styles['validation-wrapper'], styles[position]);

  const messageWrapperClass = cn(styles['message-wrapper'], styles[position], {
    [styles.floating]: isFloating,
  });

  return (
    <div className={validationWrapperClass}>
      <div>
        {children}
      </div>

      {isVisible && (
        <div className={messageWrapperClass}>
          <Message
            position={position}
            allowOverflow={allowOverflow}
          >
            {text}
          </Message>
        </div>
      )}
    </div>
  );
}
